// extracted by mini-css-extract-plugin
export var dark = "header-image-module--dark--e7cb2";
export var header = "header-image-module--header--80d05";